import GerenciamentoClusterTrv from "../../components/GerenciamentoClusterTrv/GerenciamentoClusterTrv"

function TrvGerenciamentoCluster() {
    

    return (
        <>
            <GerenciamentoClusterTrv />
        </>
    )
}

export default TrvGerenciamentoCluster